<template>
    <header class="htpall">
        <div class="htpcon">
            <!--標頭Logo-->
            <h1 class="htplogo">
                <a href="/EN/">
                    <img src="/images/mainLogo.svg" alt="Department of Bio-Industry Communication and Development" />
                </a>
            </h1>
            <div class="htpright">
                <!--標題列右側功能列表-->
                <!--網站導覽文字列表-->
                <div class="tplink">
                    <!--網站導覽-->
                    <a href="/EN/Sitemap">sitemap</a>
                    |
                    <!--台大網站-->
                    <a href="https://www.ntu.edu.tw/english/" target="_blank" title="National Taiwan University (open a new window)">National Taiwan University</a>
                </div>
                <!--全站查詢欄-->
                <div class="searchall">
                    <input class="seahbox" v-model="searchKeyWords" 
                          v-on:keyup.enter="search" placeholder="Search" />
                    <div class="seahbtn" >
                        <!--搜尋按鈕-->
                        <a href="javascript:" @click="search()" title="start searching" role="button">
                            <img src="/images/search.png" alt="search"/>
                        </a>
                    </div>
                </div>
                <!--語系切換-->
                <div class="langall">
                    <!-- TODO 動態寫入目前語系 & 判斷下拉選單目前語系並套用Class-->
                    English
                    <div class="lanselb">
                        <!--當前語系套用aclang這個class-->
                        <div class="lanbx">
                            <a @click="gotoZH()">中文</a>
                        </div>
                        <div class="lanbx">
                            <a class="aclang">English</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script>

export default{

    data(){
        return {
            //
            searchKeyWords:"",
            //
            rwd:{
                type:0,
            },
            //標題名稱
            title:"",
        };
    },
    props:["header"],
    mounted(){
        //初始化
        this.init();
        
    },
    watch:{
        header(){
           document.title = this.header.text1 +(this.header.text2?'-'+this.header.text2:"") + (this.header.text3?"-"+this.header.text3:"");
        }
    },
    methods:{
        //初始化
        init(){
            document.body.className='';
            document.body.classList.add("mbkcolor");
            //2025-11-14 移除全站查詢bootstrape 預設樣式
            $('#textfield').removeClass('form-control');

           document.title = this.header.text1 +(this.header.text2?'-'+this.header.text2:"") + (this.header.text3?"-"+this.header.text3:"");
        },
        //查詢功能
        search(){
            this.functionSearch(this.searchKeyWords);
        },
        //查詢功能
        functionSearch(data){
            if(data==null){
                alert('請輸入關鍵字');
            }else{
                //TODO 前往全站搜尋頁面
                this._go1("/EN/Search?q="+encodeURIComponent(data))
            }
        },
        gotoZH(){
            this.$router.push({
                path: this.$route.path.replace("/EN","")||"/",
                query:this.$route.query,
            });
        }
    },
};
</script>